import { DataDeadZone, postMagnetKeyInfo, ResDeviceState } from '@libs/types/response'
import { DeviceProtocol } from '../device/device_model'
import { dataProfileManage } from '@hid/snapshot/profile'
import { KK } from '@hid/define/define'

export abstract class MagnetDriver {
  abstract startCalibration(): Promise<void>
  abstract endCalibration(): Promise<void>

  abstract startTravels(): Promise<void>
  abstract endTravels(): Promise<void>

  abstract syncKeysTravels(): Promise<void>

  abstract syncSeniorkey(): Promise<void>

  abstract getKeysTravels(keys?: KK[]): Promise<postMagnetKeyInfo[]>

  abstract readOrSetDeadZone(isWrite: boolean, value?: [number, number]): Promise<[number, number]>

  abstract getKeysDeadZone(keys?: KK[]): Promise<Map<KK, DataDeadZone>>

  abstract syncKeysDeadZone(): Promise<void>

  abstract DemoDebug(): Promise<void>

  abstract destroy(): void
}

export abstract class BaseDriver {
  protected isWireless: boolean = false
  magnet: MagnetDriver | undefined

  constructor(protected DeviceHID: DeviceProtocol) {
    const fake = (this.DeviceHID as any).deviceHID.device as HIDDevice
    const isWireless = fake.collections.some((c) => c.usagePage === 17)
    this.isWireless = isWireless
  }

  public changeProfileFlag = false

  setChangeProfileFlag(flag: boolean) {
    this.changeProfileFlag = flag
  }

  get save() {
    return dataProfileManage().dataProfile
  }
  get resetKeys() {
    return dataProfileManage().ResetKeys
  }
  get resetKmeKeys() {
    return dataProfileManage().ResetKmeKeys
  }

  changeDpi(index: number) {
    dataProfileManage().changeDpi(index)
  }
  changeReportRate(value: number) {
    dataProfileManage().changeMouseReportRate(value)
  }

  clearKmeKeys() {
    dataProfileManage().clearKmeKeys()
  }

  abstract getVersion(): Promise<string>
  abstract syncCustomColor(): Promise<void>
  abstract syncLeds(): Promise<void>
  abstract syncKeys(): Promise<void>
  abstract syncMacros(): Promise<void>
  abstract syncConfig(): Promise<void>
  abstract getDeviceState(): Promise<ResDeviceState>
  abstract reset(): Promise<void>
  abstract setOrReadSpecificItem(item: string, isWrite: boolean, value: any): Promise<any>
  abstract pair24g(): Promise<number>
  abstract updateFirmware(data: number[]): Promise<boolean>

  abstract syncDecorationLed(): Promise<void>

  abstract syncDynamicColor(): Promise<boolean>
  clearResetKeys() {
    dataProfileManage().clearResetKeys()
  }

  destroy() {
    this.magnet?.destroy()
  }
}
